<template>
  <ol class="breadcrumb" v-if="breadcrumbs.length">
    <li class="breadcrumb-item" v-if="crumb.meta.breadcrumb" v-for="(crumb, i) in breadcrumbs" :key="i" data-trackname="breadcrumb">
      <b-btn variant="link"
             data-trackname="breadcrumbLink"
             v-if="i != breadcrumbs.length - 1 && breadcrumbs[i+1].meta.breadcrumb != ''"
             @click="route_push(crumb)">{{ crumb.meta.breadcrumb }}</b-btn>
      <b-btn v-else variant="link" disabled>{{ crumb.meta.breadcrumb }}</b-btn>
    </li>
  </ol>
</template>

<script>
export default {
  name: 'VueBreadcrumbs',
  data: function () {
    return {
      items: [{

      }]
    };
  },
  computed: {
    breadcrumbs: function () {
      return this.$route.matched;
    }
  },
  methods: {
    route_push: function (crumb) {
      if (crumb.meta.default) {
        this.$router.push({name: crumb.meta.default, params: this.$route.params});
      } else {
        this.$router.push({name: crumb.name, params: this.$route.params});
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/Breadcrumbs.vue